module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "config-setting-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "width": _vm.isMaximized ? '100%' : '70%',
      "visible": _vm.dialogVisible,
      "title": _vm.title,
      "close-on-click-modal": false,
      "fullscreen": _vm.isMaximized,
      "append-to-body": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    staticClass: "dialog-title-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-controls"
  }, [_c('el-button', {
    staticClass: "control-btn",
    attrs: {
      "type": "text",
      "size": "mini",
      "icon": _vm.isMaximized ? 'el-icon-copy-document' : 'el-icon-full-screen',
      "title": _vm.isMaximized ? '还原' : '最大化'
    },
    on: {
      "click": _vm.toggleMaximize
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "control-btn",
    attrs: {
      "type": "text",
      "size": "mini",
      "icon": "el-icon-close",
      "title": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })], 1)])]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabOptions), function(item) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.label,
        "name": item.name
      }
    }, [_c(item.component, {
      tag: "component",
      attrs: {
        "isMaximized": _vm.isMaximized
      },
      on: {
        "cancel": _vm.handleClose,
        "save": _vm.handleSave
      }
    })], 1)
  }), 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b499e84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/configSettingDialog.vue
// module id = 2413
// module chunks = 68